var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like-box"},[_c('canvas',{ref:"thumsCanvas",staticStyle:{"width":"100px"},attrs:{"width":"200","height":"300"}}),_c('div',[_vm._t("default",[_c('div',{staticClass:"like-btn"},[_vm._v("飘心")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }